<p class="text-center">Redirecting to <a alt="Sign In With Google" [href]="url">Sign In With Google</a>...</p>
